import { getClient } from "./client";

export const createEndMessageView = (gameId: string) =>
  getClient({ authenticate: true }).post(
    `/api/games/${gameId}/viewed-end-message`,
  );
